import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { serviceLandings } from '../../mocks/service-landings';
import SLNavbar from './components/SLNavbar';
import SLHero from './components/SLHero';
import SLProblems from './components/SLProblems';
import SLBenefits from './components/SLBenefits';
import SLProcess from './components/SLProcess';
import SLFaq from './components/SLFaq';
import SLContactForm from './components/SLContactForm';
import SLFooter from './components/SLFooter';

export default function ServiceLandingPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const data = serviceLandings.find((s) => s.slug === slug);

  useEffect(() => {
    if (!data) {
      navigate('/', { replace: true });
    }
  }, [data, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!data) return null;

  const handleCtaClick = () => {
    const el = document.querySelector('#kontaktny-formular');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <title>{data.seo.title}</title>
      <meta name="description" content={data.seo.description} />
      <link rel="canonical" href={data.og.url} />

      {/* Open Graph - Facebook & Instagram */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={data.og.url} />
      <meta property="og:title" content={data.og.title} />
      <meta property="og:description" content={data.og.description} />
      <meta property="og:image" content={data.og.image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={data.og.title} />
      <meta property="og:locale" content="sk_SK" />
      <meta property="og:site_name" content="Boostio" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@boostio_sk" />
      <meta name="twitter:title" content={data.og.title} />
      <meta name="twitter:description" content={data.og.description} />
      <meta name="twitter:image" content={data.og.image} />

      <div className="min-h-screen bg-white">
        <SLNavbar ctaLabel={data.hero.ctaPrimary} onCtaClick={handleCtaClick} />
        <SLHero data={data} onCtaClick={handleCtaClick} />
        <SLProblems data={data} />
        <SLBenefits data={data} onCtaClick={handleCtaClick} />
        <SLProcess data={data} />
        <SLFaq data={data} />
        <SLContactForm data={data} />
        <SLFooter />
      </div>
    </>
  );
}
